/**
 * A comparison function for use when using the sort() method on arrays.
 * @example: stringArray.sort(alphabetise);
 * @example: objectArray.sort((a, b) => alphabetise(a.name, b.name));
 *
 * @param { String } 'a' - the first array item to sort
 * @param { String } 'b' - the second array item sort
 * @return {Number} The position of the item in the array
 */

const alphabetise = (a, b) => {
  const itemA = a.toUpperCase();
  const itemB = b.toUpperCase();
  if (itemA < itemB) {
    return -1;
  }
  if (itemA > itemB) {
    return 1;
  }
  return 0;
};

export default alphabetise;
